import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-page min-h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "px-10 pt-10"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-yellow p-2 text-12 rounded-2 ml-4 border-all-yellow"
}
const _hoisted_6 = {
  key: 1,
  class: "text-orange p-2 text-12 rounded-2 ml-4 border-all-orange"
}
const _hoisted_7 = {
  key: 2,
  class: "text-orange p-2 text-12 rounded-2 ml-4 border-all-orange"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListTitle = _resolveComponent("ListTitle")!
  const _component_ListNewItem = _resolveComponent("ListNewItem")!
  const _component_EmptyPage = _resolveComponent("EmptyPage")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.state.refreshing,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.refreshing) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: _ctx.state.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.loading) = $event)),
          finished: _ctx.state.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad
        }, {
          default: _withCtx(() => [
            (_ctx.state.list.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "list-item",
                      onClick: ($event: any) => (
              _ctx.$router.push({
                name: _ctx.$RouterName.EVENTS_DETAIL,
                params: { id: item.id }
              })
            )
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_ListTitle, {
                          name: item.event_type_name
                        }, null, 8, ["name"]),
                        (item.is_evaluate == '3')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 待评价 "))
                          : _createCommentVNode("", true),
                        (item.is_overtime == '1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 领取超时 "))
                          : _createCommentVNode("", true),
                        (item.is_overtime_handler == '1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 处理超时 "))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_ListNewItem, {
                        style: {"margin-top":"8px"},
                        label: "编号",
                        value: item.event_code
                      }, null, 8, ["value"]),
                      _createVNode(_component_ListNewItem, {
                        label: "摘要",
                        value: item.desc,
                        twoLine: true
                      }, null, 8, ["value"]),
                      _createVNode(_component_ListNewItem, {
                        label: "时间",
                        value: item.create_time_name
                      }, null, 8, ["value"]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["list-item-status", _ctx.colors[item.event_state]])
                      }, _toDisplayString(item.event_state_name), 3)
                    ], 8, _hoisted_3))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_component_EmptyPage, {
                  key: 1,
                  style: {"margin-top":"100px !important"},
                  isHide: true
                }))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}